import * as type from '../types/payment';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestPayment = actionCreator(type.REQUEST_PAYMENT);
export var successPayment = actionCreator(type.SUCCESS_PAYMENT);
export var failurePayment = actionCreator(type.FAILURE_PAYMENT);
export var requestBulkPayment = actionCreator(type.REQUEST_BULK_PAYMENT);
export var requestCartPayment = actionCreator(type.REQUEST_CART_PAYMENT);